export const DevLoggerEnabled = (): boolean => {
 return (window.localStorage)? Boolean(window.localStorage["devlog"]*1): false;
}

const _devVars: string[] = (window.localStorage && window.localStorage['dev'])? window.localStorage['dev'].split(","): [];

export const DevVar = (name: string): boolean => Boolean(_devVars.indexOf(name) >= 0);
